import { render, staticRenderFns } from "./WebClient_Document.vue?vue&type=template&id=538a727e&scoped=true"
import script from "./WebClient_Document.vue?vue&type=script&lang=js"
export * from "./WebClient_Document.vue?vue&type=script&lang=js"
import style0 from "./WebClient_Document.vue?vue&type=style&index=0&id=538a727e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538a727e",
  null
  
)

export default component.exports